import axios from 'axios';
import qs from 'qs';

const AXIOS_CONFIG = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
};

export default class ApiHandler {
  constructor() {
    this.config = AXIOS_CONFIG;
  }

  addAuthorization(Authorization) {
    this.config.headers = Object.assign({}, this.config.headers, { Authorization });
  }

  deleteAuthorization() {
    delete this.config.headers.Authorization;
  }

  resetConfig() {
    this.config = AXIOS_CONFIG;
  }

  addIdentifierToUrl(url, identifier) {
    if (identifier && identifier.length > 0) {
      if (url.endsWith('=') || url.endsWith('/')) {
        return `${url}${identifier}`;
      }
      return `${url}/${identifier}`;
    }
    return url;
  }

  handleResponse(response, resolve, reject, fullResponse) {
    if (response.data.success) {
      resolve(fullResponse ? response.data : response.data.data);
    } else {
      reject(response.data.message);
    }
  }

  addQueryParam(url, data) {
    let queryParam = '';
    if (data && typeof (data) === 'object' && data.constructor === Object) {
      queryParam = Object.keys(data).map(key => `${key}=${data[key]}`).join('&');
    } else if (data && typeof (data) === 'string' && data.constructor === String) {
      queryParam = data;
    }

    if (queryParam.length > 0) {
      if (url.indexOf('?') > -1) {
        return `${url}&${queryParam}`;
      }
      return `${url}?${queryParam}`;
    }
    return url;
  }

  get(url, data, identifier, fullResponse) {
    return new Promise((resolve, reject) => {
      const identifiedUrl = this.addIdentifierToUrl(url, `${identifier}`);
      const stringifiedData = data ? qs.stringify(data) : '';
      this.callGet(identifiedUrl, stringifiedData)
        .then((response) => {
          this.handleResponse(response, resolve, reject, fullResponse);
        });
    });
  }

  callGet(url, data) {
    return axios.get(
      `${this.addQueryParam(url, data)}`,
      data,
      this.config,
    );
  }

  post(url, data, identifier, fullResponse) {
    return new Promise((resolve, reject) => {
      const identifiedUrl = this.addIdentifierToUrl(url, `${identifier}`);
      const stringifiedData = data ? qs.stringify(data) : '';
      this.callPost(identifiedUrl, stringifiedData)
        .then((response) => {
          this.handleResponse(response, resolve, reject, fullResponse);
        });
    });
  }

  postRaw(url, data, identifier, fullResponse) {
    return new Promise((resolve, reject) => {
      const identifiedUrl = this.addIdentifierToUrl(url, `${identifier}`);
      this.callPost(identifiedUrl, data)
        .then((response) => {
          this.handleResponse(response, resolve, reject, fullResponse);
        });
    });
  }

  callPost(url, data) {
    return axios.post(
      url,
      data,
      this.config,
    );
  }

  put(url, data, identifier, fullResponse) {
    return new Promise((resolve, reject) => {
      const identifiedUrl = this.addIdentifierToUrl(url, `${identifier}`);
      const stringifiedData = data ? qs.stringify(data) : '';
      this.callPut(identifiedUrl, stringifiedData)
        .then((response) => {
          this.handleResponse(response, resolve, reject, fullResponse);
        });
    });
  }

  putRaw(url, data, identifier, fullResponse) {
    return new Promise((resolve, reject) => {
      const identifiedUrl = this.addIdentifierToUrl(url, `${identifier}`);
      this.callPut(identifiedUrl, data)
        .then((response) => {
          this.handleResponse(response, resolve, reject, fullResponse);
        });
    });
  }

  callPut(url, data) {
    return axios.put(
      url,
      data,
      this.config,
    );
  }
}
